import React from 'react';
import { Intercom, getProd } from '@figure/frontlib-onboarding-redux';
import { Upscope } from '@figure/frontlib-gui';
import { useIdentity, useProfile } from '../hooks';
import { mode } from '../utils/ThemeHelper';

const MessagingContainer = () => {
  const { profile } = useProfile(false);
  const { identity } = useIdentity();

  const email = profile?.email || '';
  const fullName = profile?.name ? `${profile.name.firstName} ${profile.name.lastName}` : '';
  const identityUuid = identity?.uuid || '';

  return (
    <>
      {mode === 'figure' && (
        <Intercom
          appId={process.env.REACT_APP_INTERCOM_APP_ID}
          identityUuid={identityUuid}
          email={email}
          fullName={fullName}
        />
      )}

      {getProd() && (
        <Upscope
          appID={process.env.REACT_APP_UPSCOPE_APP_ID}
          identityUuid={identityUuid}
          identities={email || fullName ? [email, fullName] : null}
        />
      )}
    </>
  );
};

export default MessagingContainer;
